import React from "react";

const Field = ({
  field,
  handleFieldChanged,
  type,
  value,
  showSimplifiedOptions,
}) => {
  /* console.log("**** field ****", field);
  console.log("showSimplifiedOptions", showSimplifiedOptions); */
  return (
    <div
      className={
        field.hasOwnProperty("col") && field.col
          ? "cell medium-" + field.col
          : "medium-6 cell"
      }
      key={field._uid}
    >
      <div>
        {/* {field.hasOwnProperty("doNotDisplayLabel") &&
        field.doNotDisplayLabel === "yes" ? (
          ""
        ) : field.label ? (
          <label htmlFor={field._uid}>{field.label}</label>
        ) : (
          ""
        )} */}

        {field.hasOwnProperty("doNotDisplayLabel") &&
        field.doNotDisplayLabel === "yes"
          ? ""
          : (showSimplifiedOptions === true &&
              field &&
              field.hasOwnProperty("simplifiedLabel") &&
              field.simplifiedLabel && (
                <label htmlFor={field._uid}>{field.simplifiedLabel}</label>
              )) ||
            (field && field.hasOwnProperty("label") && field.label && (
              <label htmlFor={field._uid}>{field.label}</label>
            ))}

        {/* {(showSimplifiedOptions === true &&
          field &&
          field.hasOwnProperty("simplifiedLabel") &&
          field.simplifiedLabel && (
            <label htmlFor={field._uid}>{field.simplifiedLabel}</label>
          )) ||
          (field && field.hasOwnProperty("label") && field.label && (
            <label htmlFor={field._uid}>{field.label}</label>
          ))} */}

        <input
          type={type || field.type}
          id={field._uid}
          name={field._uid}
          value={value}
          onChange={(e) => {
            // Notify the main state list of the new value
            handleFieldChanged(field._uid, e.target.value);
          }}
          maxLength={field.maxLength && field.maxLength}
          placeholder={
            field && field.hasOwnProperty("label") && field.label && field.label
          }
        />
      </div>
    </div>
  );
};

export default Field;
